import { AxiosResponse } from "axios";
import { axiosConfigSupervisorToUpload } from "../../config/api/configApiSupervisor";
import { PaymentSetting } from "../../types/paymentSetting";
import { axiosConfigV2 } from "../../config/api/configApiv2";

export const getPaymentSetting: () => Promise<
  AxiosResponse<PaymentSetting>
> = () => {
  return axiosConfigSupervisorToUpload.get("/setting-identity/get");
};

export const getPaymentInfo: (
  courseId: number
) => Promise<AxiosResponse<any>> = (courseId: number) => {
  return axiosConfigV2.get(
    `api/student-course-payment/get-payment-info/${courseId}`
  );
};

export const getAllPayment: (payload: any) => Promise<AxiosResponse<any>> = (
  payload: any
) => {
  return axiosConfigV2.post(
    `api/mooc-course-payment-transaction/get-all-transactions`,
    payload
  );
};

export const createTransaction: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload: any) => {
  return axiosConfigV2.post(
    `api/mooc-course-payment-transaction/create-transaction`,
    payload
  );
};

export const getSchoolFilter: () => Promise<AxiosResponse<any>> = () => {
  return axiosConfigV2.get(
    `api/mooc-course-payment-transaction/get-university-filter`
  );
};

export const createVNPayTransaction: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload: any) => {
  return axiosConfigV2.post(`api/vnpay-payment/create-payment-url`, payload);
};

export const vnPayResult: (payload: any) => Promise<AxiosResponse<any>> = (
  payload
) => {
  return axiosConfigV2.put(`/api/vnpay-payment/completed-payment`, payload);
};
